import Parametros from 'Interface/Requisicao';
import Uniforme, {
  FinderUniformes,
  RetornoUniforme,
} from 'Interface/Uniformes';
import api from 'Service';

import { paramsParaString } from '../utils';

const tag = 'Uniformes';

const url = '/uniformes';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarUniformes: construtor.query<FinderUniformes, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.uniformes
            ? [
                ...resultado.uniformes.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarUniforme: construtor.query<
        RetornoUniforme,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarUniforme: construtor.mutation<
        RetornoUniforme,
        Partial<Uniforme>
      >({
        query: (dados) => ({ url: url, method: 'POST', body: dados }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarUniforme: construtor.mutation<
        RetornoUniforme,
        Partial<Uniforme> & Pick<Uniforme, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerUniforme: construtor.mutation<
        RetornoUniforme,
        Partial<Uniforme> & Pick<Uniforme, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarUniformesQuery,
  useRecuperarUniformeQuery,
  useAdicionarUniformeMutation,
  useEditarUniformeMutation,
  useRemoverUniformeMutation,
} = apiExtendida;
